<template>
    <div class="main">
        <div class="items">
            
            <wx-open-launch-weapp
                id="launch-btn1"
                class="item"
                appid="wx2360e88b91978b33" 
                username="gh_103cbfbfd5cf"
                path="/pages/recycling/index?channelAppId=s16780342"

                @error="handleErrorFn" @launch="handleLaunchFn"
                
                >
                <script type="text/wxtag-template">
                    <div class="scxdiv">
                        <div class="xcximg">
                            <img src="https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/imgs/zszy.png" alt="">
                        </div>
                        <span class='xcxspan'>再生资源</span>
                    </div>
                    <style>
                        .xcximg{
                            width:100%;
                            height:80%;
                            display:flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcximg img{
                            width: 45%;
                            height:100%;
                        }
                        .scxdiv{
                            height:100%;
                            width:100%;
                            display:flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcxspan{
                            margin-top:10px;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            font-size: 13px;
                        }
                    </style>
                </script>
            </wx-open-launch-weapp>
            <wx-open-launch-weapp
                id="launch-btn2"
                class="item"
                username="gh_103cbfbfd5cf"
                path="pages/explosiveGroup/index/index?p=community&channelAppId=s16780342"
                @error="handleErrorFn" @launch="handleLaunchFn"
                
                >
                <script type="text/wxtag-template">
                    <div class="scxdiv">
                        <div class="xcximg">
                            <img src="https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/imgs/zbsh.png" alt="">
                        </div>
                        <span class='xcxspan'>本地生活</span>
                    </div>
                    <style>
                        .xcximg{
                            width:100%;
                            height:80%;
                            display:flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcximg img{
                            width: 45%;
                            height:100%;
                        }
                        .scxdiv{
                            height:100%;
                            width:100%;
                            display:flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcxspan{
                            margin-top:10px;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            font-size: 13px;
                        }
                    </style>
                </script>
            </wx-open-launch-weapp>
            <div class="item" @click='goto("https://h5.icsaas.cn/h5/#/equityHome?appId=s16780342")'>
                <img src="../assets/qyhj.png" alt="">
                <span>社区福利</span>
            </div>
            <!-- 
                                
                                再生资源备份路径--开始
                                path="subPackages/recycling/index?rdId=428&channelAppId=s16780342"
                                再生资源备份路径--结束


                
                
                <wx-open-launch-weapp
                id="launch-btn3"
                class="item"
                username="gh_103cbfbfd5cf"
                path="subPackages/preferentialGroup/index?channelAppId=s16780342"
                @error="handleErrorFn" @launch="handleLaunchFn"
                
                >
                <script type="text/wxtag-template">
                    <div class="scxdiv">
                        <div class="xcximg">
                            <img src="https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/imgs/lltg.png" alt="">
                        </div>
                        <span class='xcxspan'>邻里团购</span>
                    </div>
                    <style>
                        .xcximg{
                            width:100%;
                            height:80%;
                            display:flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcximg img{
                            width: 45%;
                            height:100%;
                        }
                        .scxdiv{
                            height:100%;
                            width:100%;
                            display:flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcxspan{
                            margin-top:10px;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            font-size: 13px;
                        }
                    </style>
                </script>
            </wx-open-launch-weapp>
            <div class="item" @click='goto("https://h5.icsaas.cn/h5/#/goods?appId=s16780342")'>
                <img src="../assets/bksp.png" alt="">
                <span>爆款商品</span>
            </div> -->
            <wx-open-launch-weapp
                id="launch-btn3"
                class="item"
                username="gh_103cbfbfd5cf"
                path="subPackages/my/index?channelAppId=s16780342"
                @error="handleErrorFn" @launch="handleLaunchFn"
                
                >
                <script type="text/wxtag-template">
                    <div class="scxdiv">
                        <div class="xcximg">
                            <img src="https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/imgs/grzx.png" alt="">
                        </div>
                        <span class='xcxspan'>我的</span>
                    </div>
                    <style>
                        .xcximg{
                            width:100%;
                            height:80%;
                            display:flex;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcximg img{
                            width: 45%;
                            height:100%;
                        }
                        .scxdiv{
                            height:100%;
                            width:100%;
                            display:flex;
                            flex-direction: column;
                            align-items: center;
                            justify-content: center;
                        }
                        .xcxspan{
                            margin-top:10px;
                            display: inline-block;
                            width: 100%;
                            text-align: center;
                            font-size: 13px;
                        }
                    </style>
                </script>
            </wx-open-launch-weapp>
        </div>

        <div style="height:50px"></div>
    </div>
</template>
<script>
import getwxconfig from '../components/wxconfig.js' //微信sdk的封装js
export default {
    data() {
        return {
            h5list:[
                {
                    name:"爆款商品",
                    src:require('../assets/bksp.png'),
                    url:'https://h5.icsaas.cn/h5/#/goods?appId=s16780342'
                },{
                    name:"社区福利",
                    src:require('../assets/qyhj.png'),
                    url:'https://h5.icsaas.cn/h5/#/equityHome?appId=s16780342'
                },
            ],
            xcxlist:[
                {
                    name:'本地生活',
                    id:'gh_103cbfbfd5cf',
                    page:'subPackages/recycling/index?rdId=428&channelAppId=s16780342',
                    src:'https://zhwy.zjj.suqian.gov.cn/zhwy_mobile/imgs/zbsh.png'
                },
            ]
        }
    },
    created() {
        getwxconfig()
    },
    mounted () {
    },
    methods: {
        goto(url){
            window.open(url)
        },
        go(name){
            this.$router.push('/'+name)
        },
        handleErrorFn(e){
            console.log('fail', e.detail);
        },
        handleLaunchFn(e){
            console.log('success');
        },
    }
}
</script>
<style lang="less" scoped>
    .main{
    width: 100vw;
    height: 100vh;
    .topimg{
        width: 100%;
        height: 24%;
    }
    .tzgg{
        width: 100%;
        box-sizing: border-box;
        padding: 16px;
        .tztitle{
            border-left: 4px solid #0089ff;
            display: flex;
            justify-content: space-between;
            align-items: center;
            span{
                margin-left: 10px;
                font-size: 15px;
                font-weight: bold;
            }
        }
        .gd{
            color: #2e7fff;
            font-size: 15px;
        }
        .tzlist{
            display: flex;
            flex-direction: column;
            .tzitem{
                display: flex;
                flex-direction: column;
                border-bottom: 1px solid #e6e5e5;
                min-height: 10vh;
                justify-content: center;
                span:nth-child(1){
                    color: #333;
                    font-size: 15px;
                }
                span:nth-child(2){
                    margin-top: 12px;
                    color: #333;
                    font-size: 13px;
                    opacity: 0.5;
                }
            }
        }
    }
    .greyline{
        margin-top: 10px;
        height: 16px;
        background-color: #f6f6f6;
        width: 100%;
    }
    .items{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        .item{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 33%;
            height: 25.3vw;
            margin-top: 10px;
        }
        .item img{
            width: 45%;
        }
        .item span{
            margin-top: 10px;
            width: 80%;
            text-align: center;
            font-size: 13px;
        }
    }
    
}
</style>